export default () => {
  const parentContainer = $(".page-section--review"),
    slickElement = $(".js-review-slider"),
    sliderNav = parentContainer.find(".slider-nav"),
    status = parentContainer.find(".js-slide-counter"),
    nextArrow = parentContainer.find(".js-slider-arrow .btn-next-arrow"),
    prevArrow = parentContainer.find(".js-slider-arrow .btn-prev-arrow"),
    sliderSingle = $(".js-review-slider");

  slickElement.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
    if (!slick.$dots) {
      return;
    }

    const counter = (currentSlide ? currentSlide : 0) + 1,
      sumCouner = slick.$dots[0].children.length;

    if (sumCouner < 10) {
      status.html("<b>0" + counter + "</b> " + "&nbsp;/&nbsp;0" + sumCouner);
    } else if (counter < 10) {
      status.html("<b>0" + counter + "</b> " + "&nbsp;/&nbsp;" + sumCouner);
    } else {
      status.html("<b>" + counter + "</b> " + "&nbsp;/&nbsp;" + sumCouner);
    }

    if (counter === 1) {
      prevArrow.addClass("is-disable");
      nextArrow.removeClass("is-disable");
      prevArrow.attr("tabindex", "-1");
    } else if (counter === sumCouner) {
      nextArrow.addClass("is-disable");
      nextArrow.attr("tabindex", "-1");
      prevArrow.removeClass("is-disable");
      prevArrow.removeAttr("tabindex", "-1");
    } else {
      nextArrow.removeClass("is-disable");
      nextArrow.removeAttr("tabindex", "-1");
      prevArrow.removeClass("is-disable");
      prevArrow.removeAttr("tabindex", "-1");
    }

  });

  slickElement.slick({
    infinite: false,
    slidesToShow: 1,
    speed: 150,
    arrows: false,
    accessibility: true,
    ariaPolite: true,
    dsf: false,
    dots: true,
    swipe: false,
    adaptiveHeight: true,
    responsive: [{
      breakpoint: 959,
      settings: {
        fade: true,
        swipe: true
      }
    }]
  });

  parentContainer.find(".slick-list").attr("aria-live", "polite");

  nextArrow.click(function (e) {
    sliderSingle.slick("slickNext");
  });
  prevArrow.click(function (e) {
    sliderSingle.slick("slickPrev");
  });
}
